var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("业务介绍")]),_vm._v(" "),_c('p',[_vm._v("业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍")]),_vm._v(" "),_c('button',{staticClass:"btn btn_primary",staticStyle:{"margin-bottom":"15px"},on:{"click":_vm.backToPay}},[_vm._v("返回")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e14ffe7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/businessIntr.vue
// module id = null
// module chunks = 